module.exports = __webpack_public_path__ + "static/media/secondary-salaries.da8bfc2e.svg";